{
  "dataTable": {
    "view": "Ansicht",
    "columns": "Spalten",
    "rowsSelected_one": "{{count}} von {{total}} Zeile ausgewählt",
    "rowsSelected_other": "{{count}} von {{total}} Zeilen ausgewählt",
    "totalResults_one": "{{count}} Ergebnis",
    "totalResults_other": "{{count}} Ergebnisse",
    "filteredResults_one": "{{filtered}} von {{total}} Ergebnis",
    "filteredResults_other": "{{filtered}} von {{total}} Ergebnissen",
    "rowsPerPage": "Zeilen pro Seite",
    "page": "Seite {{current}} von {{total}}",
    "noResults": "Keine Ergebnisse.",
    "noResultsFound": "Keine Ergebnisse gefunden.",
    "pagination": {
      "goToFirstPage": "Zur ersten Seite",
      "goToPreviousPage": "Zur vorherigen Seite",
      "goToNextPage": "Zur nächsten Seite",
      "goToLastPage": "Zur letzten Seite"
    },
    "search": "Suchen...",
    "filterValuePlaceholder": "{{label}} eingeben...",
    "selectPlaceholder": "Auswählen...",
    "sortAscending": "Aufsteigend sortieren",
    "sortDescending": "Absteigend sortieren",
    "sortThenAscending": "Danach aufsteigend",
    "sortThenDescending": "Danach absteigend",
    "sortRank": "Sortierung {{rank}}",
    "clearSort": "Sortierung löschen",
    "addFilter": "Filter hinzufügen",
    "clearFilter": "Filter löschen",
    "hideColumn": "Spalte ausblenden",
    "filtered": "Gefiltert",
    "groupBy": "Nach {{label}} gruppieren",
    "filters": {
      "searchPlaceholder": "Suchen...",
      "selectPlaceholder": "Auswählen...",
      "all": "Alle",
      "from": "Von",
      "to": "Bis",
      "min": "Min",
      "max": "Max",
      "activeFilters": "Aktive Filter",
      "clearAll": "Alle löschen",
      "removeFilter": "Filter entfernen"
    },
    "resetColumns": "Standard wiederherstellen"
  }
}
